const notObject = (obj) => !obj || typeof obj !== 'object';

export default notObject;
